import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, ref } from 'vue'
import { FireRiskDashboardViewModel } from '../../viewmodels/FireRiskDashboard.viewmodel'
import { NetworkConnectionStatusEnum } from '../../enums/NetworkConnectionStatus.enum'
import Dropdown from '@/components/ui/dropdown/Dropdown.vue'
import { Icon } from '@iconify/vue2'
import ConnectionStatusIcon from '../ConnectionStatusIcon.vue'
import Checkbox from '@/components/ui/checkbox/Checkbox.vue'
import { onClickOutside } from '@vueuse/core'


export default /*#__PURE__*/_defineComponent({
  __name: 'FireRiskDashboardHeader.view',
  props: {
    websocketStatus: null
  },
  setup(__props: any) {



const options = ref()

const vm = inject<FireRiskDashboardViewModel>('fire-risk-dashboard-viewmodel')!

const opened = ref(false)

onClickOutside(options, () => (opened.value = false))

const disableChartSection = computed(() => !vm.showMapSection.value && !vm.showTableSection.value)
const disableMapSection = computed(() => !vm.showChartSection.value && !vm.showTableSection.value)
const disableTableSection = computed(() => !vm.showChartSection.value && !vm.showMapSection.value)

return { __sfc: true,options, vm, opened, disableChartSection, disableMapSection, disableTableSection, Dropdown, Icon, ConnectionStatusIcon, Checkbox }
}

})